import {
  USER_WEB_EVENT_DETAIL_PAGE_PATH,
  USER_WEB_PRODUCT_CATEGORY_PAGE_PATH,
} from '../../constants/service/common/commonConstants';

const getUserWebHostUrl = () => {
  if (import.meta.env?.VITE_USER_WEB_HOST_URL) {
    return import.meta.env.VITE_USER_WEB_HOST_URL;
  }
  return 'https://www.testHostUrl.com';
};

export const setChangeDragSortList = (list, sourceIndex, destinationIndex) => {
  if (sourceIndex !== destinationIndex) {
    return list.reduce((acc, item, index) => {
      if (![sourceIndex, destinationIndex].includes(index)) acc.push(item);
      else if (index === destinationIndex) {
        if (sourceIndex < destinationIndex) acc.push(item, list[sourceIndex]);
        else acc.push(list[sourceIndex], item);
      }
      return acc;
    }, []);
  }
  return list;
};

export const generateUserWebCategoryPageUrl = (mainCategoryId, subCategoryIdList) => {
  const userWebCategoryPageUrl = getUserWebHostUrl();
  let queryStr = USER_WEB_PRODUCT_CATEGORY_PAGE_PATH;

  if (mainCategoryId) {
    // 1차 카테고리 query string 설정
    queryStr += `?category=${mainCategoryId}`;
  }
  if (subCategoryIdList && subCategoryIdList.length) {
    // 2차 카테고리 query string 설정
    queryStr += `&subCategory=${subCategoryIdList.join(',')}`;
  }

  return userWebCategoryPageUrl + queryStr;
};

export const generateUserWebEventPageUrl = (eventId) => {
  const userWebCategoryPageUrl = getUserWebHostUrl();
  const queryStr = `${USER_WEB_EVENT_DETAIL_PAGE_PATH}/${eventId}`;

  return userWebCategoryPageUrl + queryStr;
};
